module.exports = __webpack_public_path__ + "static/media/no-image.8ea88382.png";